import { defaultState } from "./state";
import cpd from "./action-types";
import commonTypes from "../common/action-types";

const types = { ...commonTypes, ...cpd };

const programs = (programsState = defaultState.programs, action) => {
  switch (action.type) {
    case types.SET_PROGRAMS:
      return action.data;

    case types.ADD_OR_UPDATE_PROGRAM: {
      const tmpState = [...programsState];

      const index = tmpState.findIndex(({ id }) => id === action.data.id);

      if (index >= 0) tmpState[index] = action.data;
      else if (!!action.data) tmpState.push(action.data);

      return tmpState;
    }

    case types.CLEAN_STATE:
      return defaultState.programs;

    default:
      return programsState;
  }
};

const subPrograms = (subProgramsState = defaultState.subPrograms, action) => {
  switch (action.type) {
    case types.SET_SUB_PROGRAMS:
      return action.data;

    case types.ADD_OR_UPDATE_SUB_PROGRAM: {
      const tmpState = [...subProgramsState];

      const index = tmpState.findIndex(({ id }) => id === action.data.id);

      if (index >= 0) tmpState[index] = action.data;
      else if (!!action.data) tmpState.push(action.data);

      return tmpState;
    }

    case types.CLEAN_STATE:
      return defaultState.subPrograms;

    default:
      return subProgramsState;
  }
};

const topics = (topicsState = defaultState.topics, action) => {
  switch (action.type) {
    case types.SET_TOPICS:
      return action.data;

    case types.ADD_OR_UPDATE_TOPIC: {
      const tmpState = [...topicsState];

      const index = tmpState.findIndex(({ id }) => id === action.data.id);

      if (index >= 0) tmpState[index] = action.data;
      else if (!!action.data) tmpState.push(action.data);

      return tmpState;
    }

    case types.CLEAN_STATE:
      return defaultState.topics;

    default:
      return topicsState;
  }
};

const organizationTypes = (
  organizationTypesState = defaultState.organizationTypes,
  action,
) => {
  switch (action.type) {
    case types.SET_ORGANIZATION_TYPES:
      return action.data;

    case types.ADD_OR_UPDATE_ORGANIZATION_TYPE: {
      const tmpState = [...organizationTypesState];

      const index = tmpState.findIndex(({ id }) => id === action.data.id);

      if (index >= 0) tmpState[index] = action.data;
      else if (!!action.data) tmpState.push(action.data);

      return tmpState;
    }

    case types.CLEAN_STATE:
      return defaultState.organizationTypes;

    default:
      return organizationTypesState;
  }
};

const trainingProviders = (
  trainingProvidersState = defaultState.trainingProviders,
  action,
) => {
  switch (action.type) {
    case types.SET_TRAINING_PROVIDERS:
      return action.data;

    case types.ADD_OR_UPDATE_TRAINING_PROVIDER: {
      const tmpState = [...trainingProvidersState];

      const index = tmpState.findIndex(({ id }) => id === action.data.id);

      if (index >= 0) tmpState[index] = action.data;
      else if (!!action.data) tmpState.push(action.data);

      return tmpState;
    }

    case types.CLEAN_STATE:
      return defaultState.trainingProviders;

    default:
      return trainingProvidersState;
  }
};

const traingProviderAttachmentTypes = (
  traingProviderAttachmentTypesState = defaultState.traingProviderAttachmentTypes,
  action,
) => {
  switch (action.type) {
    case types.SET_TRAINING_PROVIDER_ATTACHMENT_TYPES:
      return action.data;

    case types.ADD_OR_UPDATE_TRAINING_PROVIDER_ATTACHMENT_TYPE: {
      const tmpState = [...traingProviderAttachmentTypesState];

      const index = tmpState.findIndex(({ id }) => id === action.data.id);

      if (index >= 0) tmpState[index] = action.data;
      else if (!!action.data) tmpState.push(action.data);

      return tmpState;
    }

    case types.CLEAN_STATE:
      return defaultState.traingProviderAttachmentTypes;

    default:
      return traingProviderAttachmentTypesState;
  }
};

const venues = (venuesState = defaultState.venues, action) => {
  switch (action.type) {
    case types.SET_VENUES:
      return action.data;

    case types.ADD_OR_UPDATE_VENUE: {
      const tmpState = [...venuesState];

      const index = tmpState.findIndex(({ id }) => id === action.data.id);

      if (index >= 0) tmpState[index] = action.data;
      else if (!!action.data) tmpState.push(action.data);

      return tmpState;
    }

    case types.CLEAN_STATE:
      return defaultState.venues;

    default:
      return venuesState;
  }
};

const trainings = (trainingsState = defaultState.trainings, action) => {
  switch (action.type) {
    case types.SET_TRAININGS:
      return action.data;

    case types.ADD_OR_UPDATE_TRAINING: {
      const tmpState = [...trainingsState];

      const index = tmpState.findIndex(({ id }) => id === action.data.id);

      if (index >= 0) tmpState[index] = action.data;
      else if (!!action.data) tmpState.push(action.data);

      return tmpState;
    }

    case types.REMOVE_TRAINING: {
      const tmpState = [...trainingsState];

      const index = tmpState.findIndex(({ id }) => id === action.id);

      if (index >= 0) tmpState.splice(index, 1);

      return tmpState;
    }

    case types.CLEAN_STATE:
      return defaultState.trainings;

    default:
      return trainingsState;
  }
};

const providerPrograms = (
  providerProgramsState = defaultState.providerPrograms,
  action,
) => {
  switch (action.type) {
    case types.SET_PROVIDER_PROGRAMS:
      return action.data;

    case types.CLEAN_STATE:
      return defaultState.providerPrograms;

    default:
      return providerProgramsState;
  }
};

const traineeCategories = (
  traineeCategoriesState = defaultState.traineeCategories,
  action,
) => {
  switch (action.type) {
    case types.SET_TRAINEE_CATEGORIES:
      return action.data;

    case types.ADD_OR_UPDATE_TRAINEE_CATEGORY: {
      const tmpState = [...traineeCategoriesState];

      const index = tmpState.findIndex(({ id }) => id === action.data.id);

      if (index >= 0) tmpState[index] = action.data;
      else if (!!action.data) tmpState.push(action.data);

      return tmpState;
    }

    case types.CLEAN_STATE:
      return defaultState.traineeCategories;

    default:
      return traineeCategoriesState;
  }
};

const trainerCategories = (
  trainerCategoriesState = defaultState.trainerCategories,
  action,
) => {
  switch (action.type) {
    case types.SET_TRAINER_CATEGORIES:
      return action.data;

    case types.ADD_OR_UPDATE_TRAINER_CATEGORY: {
      const tmpState = [...trainerCategoriesState];

      const index = tmpState.findIndex(({ id }) => id === action.data.id);

      if (index >= 0) tmpState[index] = action.data;
      else if (!!action.data) tmpState.push(action.data);

      return tmpState;
    }

    case types.CLEAN_STATE:
      return defaultState.trainerCategories;

    default:
      return trainerCategoriesState;
  }
};

const trainers = (trainersState = defaultState.trainers, action) => {
  switch (action.type) {
    case types.SET_TRAINERS:
      return action.data;

    case types.ADD_OR_UPDATE_TRAINER: {
      const tmpState = [...trainersState];

      const index = tmpState.findIndex(({ id }) => id === action.data.id);

      if (index >= 0) tmpState[index] = action.data;
      else if (!!action.data) tmpState.push(action.data);

      return tmpState;
    }

    case types.CLEAN_STATE:
      return defaultState.trainers;

    default:
      return trainersState;
  }
};

const programCategories = (
  programCategoriesState = defaultState.programCategories,
  action,
) => {
  switch (action.type) {
    case types.SET_PROGRAM_CATEGORIES:
      return action.data;

    case types.CLEAN_STATE:
      return defaultState.programCategories;

    default:
      return programCategoriesState;
  }
};

const traineeSubCategories = (
  traineeSubCategoriesState = defaultState.traineeSubCategories,
  action,
) => {
  switch (action.type) {
    case types.SET_TRAINEE_SUB_CATEGORIES:
      return action.data;

    case types.ADD_OR_UPDATE_TRAINEE_SUB_CATEGORY: {
      const tmpState = [...traineeSubCategoriesState];

      const index = tmpState.findIndex(({ id }) => id === action.data.id);

      if (index >= 0) tmpState[index] = action.data;
      else if (!!action.data) tmpState.push(action.data);

      return tmpState;
    }

    case types.CLEAN_STATE:
      return defaultState.traineeSubCategories;

    default:
      return traineeSubCategoriesState;
  }
};

const membershipRequests = (
  membershipRequestsState = defaultState.membershipRequests,
  action,
) => {
  switch (action.type) {
    case types.SET_MEMBERSHIP_REQUESTS:
      return action.data;

    case types.ADD_OR_UPDATE_MEMBERSHIP_REQUEST: {
      const tmpState = [...membershipRequestsState];

      const index = tmpState.findIndex(({ id }) => id === action.data.id);

      if (index >= 0) tmpState[index] = action.data;
      else if (!!action.data) tmpState.push(action.data);

      return tmpState;
    }

    case types.CLEAN_STATE:
      return defaultState.membershipRequests;

    default:
      return membershipRequestsState;
  }
};

const countries = (countriesState = defaultState.countries, action) => {
  switch (action.type) {
    case types.SET_COUNTRIES:
      return action.data;

    case types.CLEAN_STATE:
      return defaultState.countries;

    default:
      return countriesState;
  }
};

const venueTypes = (venueTypesState = defaultState.venueTypes, action) => {
  switch (action.type) {
    case types.SET_VENUE_TYPES:
      return action.data;

    case types.CLEAN_STATE:
      return defaultState.venueTypes;

    default:
      return venueTypesState;
  }
};

export default {
  programs,
  subPrograms,
  topics,
  organizationTypes,
  trainingProviders,
  traingProviderAttachmentTypes,
  venues,
  trainings,
  providerPrograms,
  traineeCategories,
  trainerCategories,
  trainers,
  programCategories,
  traineeSubCategories,
  membershipRequests,
  countries,
  venueTypes,
};
